export const everythingSelected = "ep50Lb";
export default {everythingSelected};